export function addUTCZoneOffset(dateString: string) {
  return dateString + '+00:00';
}
